import { Box, Pagination as MuiPagination, useMediaQuery } from "@mui/material";
import { paginationStyles } from "./pagination.styles";
import { clsx } from '../../../utils';

interface PaginationProps {
  total: number;
  page: number;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
}

export const Pagination = ({ total, page, disabled, onChange }: PaginationProps) => {
  const isLessThan920 = useMediaQuery('(max-width: 920px)');

  return (
    <Box sx={clsx(paginationStyles['wrapper'], {
      marginTop: isLessThan920 ? '24px' : '32px',
    })}>
      <MuiPagination
        count={total}
        page={page}
        onChange={onChange}
        color="primary"
        sx={clsx(paginationStyles['bar'])}
        disabled={disabled}
      />
    </Box>
  )
}
